<template>
    <div class="sentence_back" style="background-color: #275ba9">
        <div class="navigation" :style="{backgroundColor:'transparent', height:getNavCount()+'px', 'margin-top': isWeixinBrowser() ? '15px' : '0px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="clear"></div>
        </div>
        <div class="star_transition" v-if="showStarTransition && starCount > 0" @click="closeStarTransition">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="starAudio" id="star_audio"/>
        </div>
        <div class="transition" v-if="showTransition && objEnglishProgramStar!= null">
            <div class="content">
                <div class="content2">
                    <img class="icon" src="@/Images/jili.png"/>
                    <div id="id_star" class="star">
                        <div class="star_item" v-for="index of parseInt(objEnglishProgramStar.starCount)" :key="index"><img :id="'id_star_' + index"  src="../../Images/jili_star.png"/></div>
                    </div>
                    <div id="id_star_count" class="text">
                        <span class="success_tip">祝贺完成!</span>
                        <span>获得{{objEnglishProgramStar.starCount}}颗星</span>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>词卡游戏</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <audio class="audio" :src="greatAudio" id="great_audio"/>
        </div>
        <div class="wrapper" v-if="!isEmpty(objWordCards.commonWordList)">
            <div class="wrapper-content1" @click="coreWordClick">
                <div :class="isCoreWord ? 'wrapper_back' : 'wrapper_border'">
                    <span>核心词汇</span>
                </div>
                <div :class="isCoreWord ? 'wrapper_line' : ''"></div>
            </div>
            <div class="wrapper-content" @click="commonWordClick">
                <div :class="isCoreWord ? 'wrapper_border' : 'wrapper_back'">
                    <span>常见词</span>
                </div>
                <div :class="isCoreWord ? '' : 'wrapper_line'"></div>
            </div>
        </div>
        <div v-if="noShowGuideSlideCard === 0" class='popContainer' @click="guideSlideCardClick"><img
                src="../../assets/single_sentence.png"/></div>
        <Swiper v-if="wordCards.length > 0" ref="swiper" :autoPlay="false" :showIndicator="false"
                @transtionend="getNum" :style="{'margin-bottom': '60px'}" @observer="true" @observeParents="true">
            <Slide v-for="(item,index) in wordCards" :key="index">
                <div class="main_content" :style="{marginTop: computeTopMargin() + 'px'}">
                    <img class="img_show" v-lazy="$qiNiuDomainBase + item.picture"
                         @click="playAudio(item.audio)">
                    <div class="audio_playing img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}"
                         src="@/assets/word_course_volume3.png" height="30" width="30"/>

                    <div class="page_num">
                        {{index + 1}} / {{wordCards.length}}
                    </div>

                    <div class="english_interpretation"
                         v-if="!isEmpty(item.chineseAndEnglishInterpretation)"
                         @click="popupClick(index)">
                        <img src="@/assets/icon_english_english.png" height="15" width="15"/>
                        <span>中英解释</span>
                    </div>
                </div>
            </Slide>
        </Swiper>

        <audio v-bind:src="audioUrl" id="musicMp3" @ended="playEnded" @error="playEnded" autoplay="autoplay"
               controls=""/>

        <mt-popup
                v-model="popupVisible"
                popup-transition="popup-fade"
                class="popup_style">
            <div v-if="!isEmpty(interpretationContent)" @click="closePopup">
                <pre>{{interpretationContent}}</pre>
            </div>
        </mt-popup>

        <div class="sentence_sound_recording"
             :style="{position: judgePlatform() === 3 || judgePlatform() === 4 ? 'fixed' : 'relative'}">
            <div class="audio_record_anim recording" :style="{display: isRecording ? '' : 'none'}"
                 @click="endEvaluating"></div>
            <div v-if="noShowGuideRecord === 0" class="bubbleContainer" @click="guideRecordClick">
                <div class="text">点这里录音</div>
                <div class="img"><img src="../../assets/arrow_drop_right.png"/></div>
            </div>
            <div class="recording" :style="{display: isRecording ? 'none' : ''}" @click="evaluatingWithType"><img
                    src="../../assets/icon_record_audio.png"/></div>
            <div class="playing" :style="{display: isEmpty(currentSentenceUrl) ? 'none' : ''}"
                 @click="isPlayRecording ? playEnded() : playRecordAudio(currentSentenceUrl)">
                <img v-if="isPlayRecording" src="../../assets/icon_pause.png">
                <img v-else src="../../assets/icon_play.png"/></div>
        </div>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import {Swiper, Slide} from 'vue-swiper-component';
    import Vue from 'vue'
    import {Indicator, MessageBox, Toast} from "mint-ui";
    import $ from "jquery";
    import Utils from '@/pages/Program/util2.js';
    const vRecordSoundType = 5;

    export default {
        name: "index",
        components: {
            Swiper,
            Slide
        },
        data() {
            return {
                lessonId: 0,
                cardIndex: 0,
                objWordCards: {},
                wordCards: [],
                screenWidth: document.body.clientWidth,
                audioUrl: "",
                interpretationContent: "",
                popupVisible: false,
                isPlaying: false,
                isRecording: false,
                isPlayRecording: false,
                tiemr: null,
                currentSentenceUrl: "",
                noShowGuideSlideCard: 1,
                noShowGuideRecord: 1,
                objBackground:{},
                isCoreWord: true,
                showTransition: false,
                objEnglishProgramStar: null,
                greatAudio:"https://img.xiaohuasheng.cn/great.mp3",
                starAudio:null,
                starCount:0,
                showStarTransition:false
            }
        },
        mounted() {
            window.startCountDown = this.startCountDown;
        },
        methods: {
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            gameQuitClick() {
                this.showTransition = false;
                this.$router.go(-1);
            },
            nextPageClick: function () {
                this.$router.replace({name: "PCardGame", query: {lessonId: this.lessonId}});
            },
            closePage: function () {
                this.showTransition = false;
                this.$router.go(-1);
            },
            videoClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                let type = that.objEnglishProgramStar.type;

                if (type === 2) {
                    this.$router.replace({name: "PBook", query: {lessonId: this.lessonId}});
                } else if (type === 1) {
                    this.$router.replace({name: "PVideo", query: {type: this.objEnglishProgramStar.type, lessonId: this.lessonId}});
                }
            },
            playGameClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PDropQuestion", query: {lessonId: this.lessonId}});
            },
            childDialogueClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PDialogue", query: {lessonId: this.lessonId}});
            },
            childDevelopmentClick: function () {
                let that = this;
                if (that.mustBuy()) {
                    return;
                }

                this.showTransition = false;
                this.$router.replace({name: "PExpansion", query: {lessonId: this.lessonId}});
            },
            replayClick: function () {
                let that = this;
                that.showTransition = false;
                that.cardIndex = 0;
                that.$refs.swiper.slideTo(parseInt(that.cardIndex));
            },
            closeTransition() {
                this.closePage();
            },
            getEnglishProgramStar() {
                // 类型（1看视频或绘本/2词卡/3做游戏/4词卡游戏/5语言游戏/6认知游戏/7上节课Review）
                let that = this;
                let url = "englishProgram/getEnglishProgramStar/" + that.lessonId + "/2";
                this.$axios.get(url).then((response) => {
                    that.objEnglishProgramStar = response.data;
                    let vStarCount = that.getCount(that.objEnglishProgramStar.starCount);
                    window.console.log("vStarCount:" +vStarCount);

                    if (vStarCount > 0) {
                        that.showTransition = true;

                        setTimeout(() => {
                            const greatAudio = document.getElementById('great_audio');
                            greatAudio.play();

                            for(let i = 1; i <= vStarCount; i++) {
                                $("#id_star_" + i).show(300 + i*500, function(){});
                            }
                        }, 200);

                        Utils.$emit('setStarCount', '3');
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            showReplayAnimate:function () {
                let that = this;

                $(".wrapper_replay").animate({height:"44px", width:"154px"},500,function(){
                    $(".wrapper_replay").animate({height:"40px", width:"150px"} ,500, that.showReplayAnimate);
                });
            },
            mustBuy: function() {
                let that = this;
                let isBuy = that.objEnglishProgramStar.isBuy;
                let freeTrial = that.objEnglishProgramStar.freeTrial;

                if (isBuy === 0 && freeTrial === 0) {
                    MessageBox.confirm('', {
                        message: ' ',
                        title: '要先购买才能上课哦～快去购买吧！',
                        showConfirmButton:false,
                        showCancelButton:true,
                        closeOnClickModal: false,
                        cancelButtonClass:'cancelButton',
                        confirmButtonClass:'confirmButton',
                        cancelButtonText:'知道了'
                    });
                    return true;
                }

                return false;
            },
            coreWordClick: function() {
                let that = this;
                that.isCoreWord = true;
                that.getLessonWordData(1);
            },
            commonWordClick: function() {
                let that = this;
                that.isCoreWord = false;
                that.getLessonWordData(2);
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            goToBack() {
                this.goBack(this.$router);
            },
            nextClick() {
                this.$router.push({name: "PExpansion", query: {lessonId: this.lessonId}});
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            computeTopMargin: function () {
                let width = document.documentElement.clientWidth;
                let height = document.documentElement.clientHeight;
                let that = this;
                let topMargin = (height - Math.min(560, width) - (that.isEmpty(that.objWordCards.commonWordList) ? 0 : 80) - 90 - that.getNavCount())/2;
                return topMargin;
            },
            guideSlideCardClick: function () {
                let that = this;

                if (that.noShowGuideSlideCard === 1) {
                    return;
                }

                that.$axios.get("englishProgram/saveGuidePrompt/key5").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideSlideCard = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            guideRecordClick: function () {
                let that = this;

                if (that.noShowGuideRecord === 1) {
                    return;
                }

                that.$axios.get("englishProgram/saveGuidePrompt/key6").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideRecord = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            suspendRecord() {
                let that = this;

                if (!that.isRecording) {
                    return;
                }

                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];
                that.isRecording = false;

                if (vPlatform === 1 || vPlatform === 2) {
                    // 终止录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("终止录音: 微信平台");
                    // 停止录音
                    that.isCountDowning = false;
                    wx.stopRecord({});
                } else if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("终止录音: IOS平台");

                    let vUrl = "readingclubapp:suspendRecord:" + wordCard.pk + ":" + vRecordSoundType;
                    document.location = vUrl;
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("终止录音: android平台");

                    window.note.suspendRecord(parseInt(wordCard.pk), vRecordSoundType);
                } else {
                    window.console.log("终止录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            evaluatingWithType() {
                let that = this;
                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];
                that.isRecording = true;

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    document.location = "readingclubapp:evaluatingWithType:1:" + wordCard.word;
                } else if (vPlatform === 4) {
                    window.console.log("evaluating");
                    // 4-app平台android平台
                    window.note.evaluatingWithType(1, wordCard.word);
                }
            },
            endEvaluating() {
                let that = this;
                that.isCountDowning = false;
                that.isRecording = false;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    document.location = "readingclubapp:endEvaluating";
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.note.endEvaluating();
                }
            },
            evaluatingResult(result) {
                // 返回测评结果处理
                let that = this;
                let vScore = parseFloat(result);
                that.starCount = that.getProgramStarCount(vScore);
                that.starAudio = that.getProgramAudioUrl(that.starCount);
                that.showStarTransition = true;

                setTimeout(() => {
                    for(let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i*100, function(){});
                    }

                    const starAudio = document.getElementById('star_audio');

                    if (starAudio != null) {
                        starAudio.play();
                    }
                }, 200);
            },
            closeStarTransition() {
                this.showStarTransition = false;
            },
            startRecording() {
                let that = this;

                if (that.isRecording) {
                    return;
                }

                // 关闭引导页
                that.guideRecordClick();
                that.playEnded();
                let wordCard = that.wordCards[that.cardIndex];
                let vPlatform = that.judgePlatform();
                let second = 5;

                if (vPlatform === 1 || vPlatform === 2) {
                    // 开启录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("开启录音: 微信平台");

                    wx.startRecord({
                        success: function (res) {
                            window.console.log(JSON.stringify(res));
                            that.isRecording = true;
                            that.startCountDown();
                        },
                        fail: function (res) {
                            window.console.log(JSON.stringify(res));
                            Toast('录音开启失败');
                        }
                    });
                } else if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("开启录音: IOS平台");

                    let vUrl = "readingclubapp:startRecord:" + wordCard.pk + ":" + vRecordSoundType + ":" + second + ":" + 0;
                    document.location = vUrl;
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("开启录音: android平台");

                    window.note.startRecord(parseInt(wordCard.pk), vRecordSoundType, parseInt(second), 0);
                } else {
                    window.console.log("开启录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            sentenceStartRecordAnimation() {
                this.isRecording = true;
            },
            sentenceEndRecordAnimation() {
                this.isRecording = false;
                Indicator.open('上传中...');
            },
            sentenceCloseIndicator() {
                Indicator.close();
            },
            endRecording() {
                let that = this;
                that.isCountDowning = false;
                that.isRecording = false;
                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];

                if (vPlatform === 1 || vPlatform === 2) {
                    // 关闭录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("关闭录音: 微信平台");

                    // 停止录音
                    wx.stopRecord({
                        success: function (res) {
                            Indicator.open('上传中...');
                            window.console.log("停止录音：" + JSON.stringify(res));

                            // 上传音频到微信服务器
                            wx.uploadVoice({
                                localId: res.localId,
                                isShowProgressTips: 0,
                                success: function (uploadRes) {
                                    window.console.log(JSON.stringify(uploadRes));
                                    // 上传音频到其谬服务器
                                    that.saveUserAudio(uploadRes.serverId, uploadRes.localId, wordCard.pk, 0);
                                },
                                fail: function (uploadRes) {
                                    window.console.log(JSON.stringify(uploadRes));
                                    Indicator.close();
                                    Toast('录音上传失败');
                                }
                            });
                        },
                        fail: function (res) {
                            window.console.log(JSON.stringify(res));
                            Toast('录音停止失败');
                        }
                    });
                } else if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("关闭录音: IOS平台");

                    let vUrl = "readingclubapp:stopRecord:" + wordCard.pk + ":" + vRecordSoundType;
                    document.location = vUrl;
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("关闭录音: android平台");

                    window.note.stopRecord(parseInt(wordCard.pk), vRecordSoundType);
                } else {
                    window.console.log("关闭录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            saveUserAudio(mediaId, localId, cardId, sentenceId) {
                let that = this;
                let wordCard = that.wordCards[that.cardIndex];
                let url = "240words/recordingService/";

                that.$axios.post(url,
                    {type: vRecordSoundType, pk: wordCard.pk, mediaId: mediaId})
                    .then((response) => {
                        window.console.log("录音保存七牛：" + JSON.stringify(response.data));
                        Indicator.close();

                        if (response.data != null && response.data.code != -1) {
                            if (that.getCount(response.data.code) === 1) {
                                window.PLessonRefreshData = 1;
                            }

                            that.wordCards.forEach((item, index) => {
                                if (cardId === item.pk) {
                                    item.userAudio = response.data.audio;
                                    Vue.set(that.wordCards, index, item);
                                }
                            });

                            that.playRecordAudio2(response.data.audio, mediaId, false);

                            // 播放监听
                            wx.onVoicePlayEnd({
                                complete: function (res) {
                                    window.console.log("播放完成：" + JSON.stringify(res));
                                    that.playEnded();
                                }
                            });

                            // 播放录音
                            wx.playVoice({
                                localId: localId
                            });

                            //  是否完成所有录音
                            let isFinishRecordAll = true;

                            that.wordCards.forEach((item, index) => {
                                if (that.isEmpty(item.userAudio)) {
                                    isFinishRecordAll = false;
                                }
                            });

                            if (isFinishRecordAll) {
                                window.console.log("isFinishRecordAll:" + isFinishRecordAll);
                                that.getEnglishProgramStar();
                            }
                        } else {
                            Toast('录音上传失败');
                        }
                    });
            },
            startCountDown() {
                let that = this;
                let second = 5;
                this.isCountDowning = true;
                that.codeCountDown(second);
            },
            codeCountDown(second) {
                let that = this;
                let time = setTimeout(() => {
                    if (!this.isCountDowning) {
                        clearTimeout(time);
                        return;
                    }

                    clearTimeout(time);
                    that.endRecording();
                }, second * 1000);
            },
            popupClick(index) {
                let cardItem = this.wordCards[index];

                if (!this.isEmpty(cardItem.chineseAndEnglishInterpretation)) {
                    this.interpretationContent = cardItem.chineseAndEnglishInterpretation;
                    this.popupVisible = true;
                }
            },
            closePopup: function () {
                this.popupVisible = false;
            },
            playAudio(audio) {
                let that = this;
                that.suspendRecord();
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;

                setTimeout(() => {
                    that.isPlaying = true;
                    that.isPlayRecording = false;
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.then(() => {
                        }).catch((e) => {
                            let vError = JSON.stringify(e);

                            if (!that.isEmpty(vError) && vError != "{}") {
                                that.isPlaying = false;
                                window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                            }
                        });
                    } else {
                        that.isPlaying = false;
                        window.console.log("播放失败:playAudio");
                    }
                }, 200);
            },
            playStart() {
                this.isPlaying = true;
            },
            playEnded() {
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                this.isPlayRecording = false;
                this.isPlaying = false;
            },
            sentencePlayRecordAudio(audio, finish, wordCardId, sentenceId) {
                // 句子完成
                let that = this;

                if (that.getCount(finish) === 1) {
                    window.PLessonRefreshData = 1;
                }

                that.wordCards.forEach((item, index) => {
                    if (wordCardId === item.pk) {
                        item.userAudio = audio;
                        Vue.set(that.wordCards, index, item);
                    }
                });

                let wordCard = that.wordCards[that.cardIndex];
                let vPlatform = that.judgePlatform();

                if (wordCardId === wordCard.pk) {
                    this.playRecordAudio2(audio, "", vPlatform !== 3);
                }

                //  是否完成所有录音
                let isFinishRecordAll = true;

                that.wordCards.forEach((item, index) => {
                    if (that.isEmpty(item.userAudio)) {
                        isFinishRecordAll = false;
                    }
                });

                if (isFinishRecordAll) {
                    that.getEnglishProgramStar();
                }
            },
            playRecordAudio(audio) {
                this.playRecordAudio2(audio, "", false);
            },
            playRecordAudio2(audio, wxMediaId, autoPlay) {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlayRecording) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                that.currentSentenceUrl = audio;

                window.console.log(that.audioUrl);
                that.isPlaying = false;
                that.isPlayRecording = true;

                if (!autoPlay && that.isEmpty(wxMediaId)) {
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.catch((e) => {
                            that.isPlayRecording = false;
                            window.console.log("播放失败:playRecordAudio2:" + e);
                        })
                    } else {
                        that.isPlayRecording = false;
                        window.console.log("播放失败:playRecordAudio2");
                    }
                }
            },
            getNum(data) {
                let that = this;

                //输出轮播到第几张图片
                if (data < that.wordCards.length) {
                    that.cardIndex = data;
                    let wordItem = that.wordCards[data];
                    that.playAudio(wordItem.audio);
                    that.currentSentenceUrl = wordItem.userAudio;
                }
            },
            getLessonWordData(type) {
                let that = this;
                that.wordCards = [];

                var t;
                clearTimeout(t);
                t = setTimeout(function () {
                    that.wordCards = type === 1 ? that.objWordCards.coreWordList : that.objWordCards.commonWordList;
                    that.getNum(0);
                }, 300);
            },
            wxRecordConfig(data) {
                let appId = data.appId;
                let timestamp = data.timestamp;
                let nonceStr = data.nonceStr;
                let signature = data.signature;

                wx.config({
                    debug: false,
                    appId: appId,
                    timestamp: timestamp,
                    nonceStr: nonceStr,
                    signature: signature,
                    jsApiList: [
                        'startRecord',
                        'stopRecord',
                        'onVoiceRecordEnd',
                        'playVoice',
                        'onVoicePlayEnd',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'uploadImage']
                });
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
        },
        created() {
            let that = this;
            // 客户端调用方法组
            window.sentenceStartRecordAnimation = that.sentenceStartRecordAnimation;
            window.sentenceEndRecordAnimation = that.sentenceEndRecordAnimation;
            window.sentencePlayRecordAudio = that.sentencePlayRecordAudio;
            window.sentenceCloseIndicator = that.sentenceCloseIndicator;
            window.evaluatingResult = that.evaluatingResult;

            // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
            if (that.isWeixinBrowser()) {
                this.$axios.post("fwh/getSignature", {
                    url: that.judgePlatform() === 1 ? window.location.protocol + "//" + window.location.host + "/" : window.location.href
                }).then((response) => {
                    that.wxRecordConfig(response.data);
                });
            }
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getWordCardInLesson/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.objWordCards = response.data;
                that.wordCards = that.objWordCards.coreWordList;

                that.noShowGuideSlideCard = that.getCount(that.objWordCards.key5);
                that.noShowGuideRecord = that.getCount(that.objWordCards.key6);
                that.lessonId = vlessonId;
                that.cardIndex = 0;

                that.stopOtherAudio();

                let wordAudio = "";

                if (!that.isEmpty(that.wordCards)) {
                    let wordCard = that.wordCards[0];
                    wordAudio = wordCard.audio;
                    that.audioUrl = that.$qiNiuDomainBase + wordAudio;
                    that.currentSentenceUrl = wordCard.userAudio;
                    that.objBackground = wordCard.background;
                }

                var t;
                clearTimeout(t);
                t = setTimeout(function () {
                    that.isPlaying = true;
                    window.PLessonRefreshData = 0;

                    if (!that.isEmpty(wordAudio)) {
                        that.playAudio(wordAudio);
                    }
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    .sentence_back {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
    }
    .navigation {
        position: relative;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 44px;
        color: white;
        font-size: 25px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .action_left {
        margin-left: 20px;
        height: 44px;
        float: left;
    }
    .navigation .action_left img {
        width:20px;
        float: left;
        margin-right:3px;
        margin-top: 13px;
    }
    .navigation .action_left span {
        float: left;
        line-height: 44px;
        font-size: 15px;
        color: white;
    }
    .navigation .right_post {
        width: 80px;
        height: 30px;
        float: right;
        position: absolute;
        right: 15px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
        background-color: #FFAA00;
        font-size: 16px;
        font-weight: bold;
        color: white;
        text-align: center;
        line-height: 30px;
    }

    .wrapper {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 15px;
    }

    .wrapper-content1 {
        width: calc(50% - 30px);
        margin-left: 30px;
        text-align: center;
        margin-top: 20px;
    }

    .wrapper-content {
        width: calc(50% - 30px);
        margin-right: 30px;
        text-align: center;
        margin-top: 20px;
    }

    .wrapper-content .wrapper_back, .wrapper-content1 .wrapper_back {
        width: 100px;
        background-color: white;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        border: 2px solid #fda228;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    .wrapper-content .wrapper_border, .wrapper-content1 .wrapper_border {
        width: 100px;
        background-color: transparent;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        border: 1.5px solid #99999999;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        z-index: 998;
    }

    .wrapper-content1 span {
        height: 30px;
        color: #fda228;
        line-height: 30px;
        vertical-align: middle;
        font-size: 16px;
        font-weight: bold;
    }

    .wrapper-content span {
        height: 25px;
        color: #fda228;
        line-height: 30px;
        vertical-align: middle;
        font-size: 16px;
        font-weight: bold;
    }

    .wrapper_line {
        width: 80px;
        height: 2px;
        background-color: #fda228;
        margin-top: 3px;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }

    .main_content {
        max-width: 560px;
        width: 100%;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        margin-top: 30px;
    }

    .main_content .img_show {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: calc(100% - 100px);
        margin: auto;
    }

    .main_content .img_play {
        position: absolute;
        right: 65px;
        top: 15px;
    }

    audio {
        display: none;
    }

    .main_content .page_num {
        margin-top: 10px;
        color: white;
        text-align: center;
        font-size: 17px;
    }

    .english_interpretation {
        position: absolute;
        right: 0px;
        margin-top: 10px;
        bottom: 2px;
    }

    .english_interpretation img {
        float: left;
        margin-top: 4px;
        margin-right: 5px;
    }

    .english_interpretation span {
        color: white;
        padding-right: 50px;
    }

    .popup_style {
        width: calc(100% - 60px);
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .popup_style pre {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .sentence_sound_recording {
        width: 100%;
        height: 70px;
        bottom: 20px;
    }

    .sentence_sound_recording .recording {
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }

    .sentence_sound_recording .recording img {
        width: 70px;
        height: 70px;
    }

    .sentence_sound_recording .playing {
        position: absolute;
        right: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .sentence_sound_recording .playing img {
        width: 35px;
        height: 35px;
    }

    .audio_record_anim {
        width: 70px; /*宽高尺寸任意增减*/
        height: 70px;
        background: url(../../assets/record_audio_anim.png) no-repeat;
        background-size: 1000% 100%;
        -webkit-animation: line-slow 0.8s steps(9) infinite;
        animation: line-slow 0.8s steps(9) infinite;
    }

    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    .popContainer {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .popContainer img {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        width: 70%;
        max-width: 400px;
    }

    .bubbleContainer {
        position: absolute;
        left: calc(50% - 99px);
        bottom: 21.5px;
        -webkit-transform: translateX(calc(50% - 99px));
    }

    .bubbleContainer .text {
        display: inline-block;
        color: #333333;
        background-color: white;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }

    .bubbleContainer .img {
        position: absolute;
        top: 5px;
        right: -9px;
        display: inline-block;
        width: 15px;
    }

    .bubbleContainer .img img {
        width: 15px;
    }

    .first_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(85, 85, 85, 0.96);
        z-index: 1005;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .first_content {
        position:relative;
    }

    .first_transition .first_content img {
        position: absolute;
        width: 79px;
        top: -50px;
        right: 20px;
    }

    .first_transition .first_content .content {
        background-color: #fef67e;
        width: calc(100vmin - 40px);
        padding: 30px 20px 20px 20px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border: 3px solid rgba(0, 0, 0, 1);
    }

    .first_transition .first_content .content .text {
        font-size: 16px;
        color: #101010;
    }
    .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmax;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .icon {
        margin-bottom: 10px;
        width: 35%;
    }
    .transition .content .text {
        width: 100%;
        margin-top: 5px;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 24px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        display: inline-block;
        margin-top: 60px;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 60px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .star_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .star_transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmax;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .star_transition .content2 {
        text-align: center;
    }
    .star_transition .content2 .star_show {
        position: relative;
        width: 234px;
        height: 95px;
    }
    .star_transition .content2 .star_show .icon1 {
        position: absolute;
        display: inline-block;
        left: 0;
        bottom: 0;
    }
    .star_transition .content2 .star_show .icon2 {
        position: absolute;
        display: inline-block;
        left: 83px;
    }
    .star_transition .content2 .star_show .icon3 {
        position: absolute;
        display: inline-block;
        left: 165px;
        bottom: 0;
    }
    .star_transition .content2 .star_show img {
        width: 68px;
        height: 68px;
    }
    .star_transition .content2 .star_show div {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .star_transition .content2 .star_score {
        margin-top: 20px;
    }
    .star_transition .content2 .star_score img {
        width: 19px;
        height: 19px;
        display: inline-block;
        vertical-align: middle;
    }
    .star_transition .content2 .star_score span {
        color: white;
        display: inline-block;
        vertical-align: middle;
        margin-left: 3px;
    }
</style>
